import { render, staticRenderFns } from "./PaymentColSettings.vue?vue&type=template&id=16e8aee2&scoped=true"
import script from "./PaymentColSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentColSettings.vue?vue&type=script&lang=ts"
import style0 from "./PaymentColSettings.vue?vue&type=style&index=0&id=16e8aee2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8aee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e8aee2')) {
      api.createRecord('16e8aee2', component.options)
    } else {
      api.reload('16e8aee2', component.options)
    }
    module.hot.accept("./PaymentColSettings.vue?vue&type=template&id=16e8aee2&scoped=true", function () {
      api.rerender('16e8aee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/PaymentColSettings.vue"
export default component.exports